import { HttpInterceptorFn } from "@angular/common/http";
import { environment } from "@env/environment";
import { BYPASS_AUTH } from "../../../constants";

/**
 * Auth Interceptor que verifica que las peticiones internas tengan withCredentials
 * Nota: correlationInterceptor ya añade withCredentials y x-requested-by,
 * este interceptor actúa como backup y verificación adicional
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const isInternalApi = isInternalApiRequest(req.url);

  if (!isInternalApi || BYPASS_AUTH) {
    return next(req);
  }

  // Solo modificar si no tiene ya withCredentials
  if (req.withCredentials) {
    return next(req);
  }

  const authReq = req.clone({
    withCredentials: true,
    setHeaders: {
      "x-requested-by": "horus-web",
    },
  });

  return next(authReq);
};

function isInternalApiRequest(url: string): boolean {
  const isInternal = url.startsWith(environment.BASE_API);

  return isInternal;
}
